/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { rhythm } from "../utils/typography"

const FooterBio = () => {
  const data = useStaticQuery(graphql`
    query FooterBioQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 50, height: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
            github
          }
        }
      }
    }
  `)

  const { author } = data.site.siteMetadata
  return (
    <div
      style={{
        display: `block`,
        marginBottom: rhythm(2.5),
        boxShadow: `none`,
      }}
    >
      <Link
        style={{
          color: "#1DA1F2",
          fontSize: "17px",
          fontFamily: `Montserrat, sans-serif`,
          fontWeight: `bold`,
          boxShadow: `none`,
        }}
        to={`/`}
      >
        {author.name}
      </Link>
    </div>
  )
}

export default FooterBio
